import type { ArcanaType, Element, Suit, TarotCard } from '@lilith-arcana-os/domain';

import { FULL_DECK_CORE } from './full-deck';

export const byId = new Map<number, TarotCard>(FULL_DECK_CORE.map((card) => [card.id, card]));
export const bySlug = new Map<string, TarotCard>(FULL_DECK_CORE.map((card) => [card.slug, card]));
export const bySuit = new Map<Suit, TarotCard[]>(
  (['Bastoni', 'Coppe', 'Spade', 'Denari'] as const).map((suit) => [
    suit,
    FULL_DECK_CORE.filter((card) => card.suit === suit),
  ]),
);
export const byArcana = new Map<ArcanaType, TarotCard[]>(
  (['major', 'minor'] as const).map((arcana) => [
    arcana,
    FULL_DECK_CORE.filter((card) => card.arcana === arcana),
  ]),
);
export const byElement = new Map<Element, TarotCard[]>(
  (['Fuoco', 'Acqua', 'Aria', 'Terra'] as const).map((element) => [
    element,
    FULL_DECK_CORE.filter((card) => card.element === element),
  ]),
);

export function getCardById(id: number): TarotCard | undefined {
  return byId.get(id);
}

export function getCardBySlug(slug: string): TarotCard | undefined {
  return bySlug.get(slug);
}

export function getCardsBySuit(suit: Suit): TarotCard[] {
  return bySuit.get(suit) ?? [];
}

export function getMajorArcana(): TarotCard[] {
  return byArcana.get('major') ?? [];
}

export function getMinorArcana(): TarotCard[] {
  return byArcana.get('minor') ?? [];
}
